<template>
    <b-input-group
        :append="append"
        :prepend="prepend"
        :size="size"
    >
        <template v-if="!prepend && $slots.prepend">
            <slot name="prepend" />
        </template>

        <slot />

        <template v-if="!append && $slots.append">
            <slot name="append" />
        </template>
    </b-input-group>
</template>

<script>
import { BInputGroup } from 'bootstrap-vue'

export default {
    components: { BInputGroup },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        }
    },
    props: {
        append: { type: String, default: null },
        large: { type: Boolean, default: false },
        prepend: { type: String, default: null },
        small: { type: Boolean, default: false },
    }
}
</script>